module.exports = __webpack_public_path__ + "img/Arrow-Micro-Dark.e0fd259.svg";